import { all } from 'redux-saga/effects';
import { authSaga } from './Auth/Auth.saga';
import { adminUsersListWatchers } from './Admin/UsersList/UsersList.saga';
import { adminDasboardWatchers } from './Admin/Dashboard/Dashboard.saga';
import { sensorDetailsWatchers } from './SensorDetails/SensorDetails.saga';

export function* rootSagas() {
  yield all([
    authSaga(),
    ...adminUsersListWatchers,
    ...adminDasboardWatchers,
    ...sensorDetailsWatchers,
  ]);
}
